import { Routes } from "@angular/router";
import { MAP_ROUTE, NURSERIES_ROUTE, SPHERES_ROUTE } from "../../crossconcern/utilities/properties/routename.property";
import { NurseriesSphereComponent } from "./spheres";
import { EMPTY_PATH, MAP_PATH, SPHERE_PATH } from "../../crossconcern/utilities/properties/path.property";
import { NurseriesComponent } from "./nurseries.component";
import { FrontMapComponent } from "./map/frontmap.component";

export const NURSERIES_ROUTES: Routes = [
    {
        path: EMPTY_PATH,
        pathMatch: "full",
        component: NurseriesComponent,
        data: { routeName: NURSERIES_ROUTE }
    },
    {
        path: SPHERE_PATH + "/:id",
        component: NurseriesSphereComponent,
        data: { routeName: SPHERES_ROUTE }
    },
    {
        path: MAP_PATH + "/:id",
        component: FrontMapComponent,
        data: { routeName: MAP_ROUTE }
    }
];